<template>  
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Costos de Productos por Proveedor</h4>
            <div class="small text-muted">Administración general de precios de costo y venta</div>
          </b-col>
          <b-col cols="auto" class="d-flex align-items-center">
            <WidgetVisibilityConfig
              :widgets="widgetsMeta"
              :hidden="hiddenWidgets"
              :disabled="!visibilityLoaded"
              :locked="editingLocked"
              @toggle="onToggleWidget"
              @reset="resetWidgetsVisibility"
              @toggle-lock="setEditingLocked($event)"
            />
            <ChangelogWidget moduleKey="costs" :limit="5" />
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
          <WidgetMasonry
            v-if="visibilityLoaded"
            v-model="widgetsOrdered"
            :disabled="!visibilityLoaded || editingLocked"
            @order-end="saveWidgetOrder"
            @resize-end="commitWidgetSize"
          >
            <template v-slot:default="{ item }">
                <Widget
                  :configWidget="configWidget"
                  :reference="item.reference"
                  :hasAccess="item.hasAccess"
                  :allowHide="!editingLocked"
                  :allowDrag="!editingLocked"
                  :allowResize="!editingLocked"
                  @hide-widget="hideWidget"
                />
            </template>
          </WidgetMasonry>
        </b-col>  
        <b-col md="3">
          <b-list-group class="mb-1" v-if="configSubView.elements.products">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openSuppliersProducts()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Productos por Proveedor</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administrador de listas de precios de cada proveedor
              </p>
            </b-list-group-item>
          </b-list-group>

          <b-list-group class="mb-1" v-if="configSubView.elements.product_suppliers_by_barcode">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openProductSuppliersByBarcode()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Gestión de Productos</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Gestión centralizada del producto por código de barra
              </p>
            </b-list-group-item>
          </b-list-group>

          <b-list-group class="mb-1" v-if="configSubView.elements.import">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openImportLog()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Importaciones</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Muestra todas las importaciones realizadas
              </p>
            </b-list-group-item>
          </b-list-group>          

          <b-list-group class="mb-1" v-if="configSubView.elements.external">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openUpdateExternal()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Actualizaciones Externas</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Muestra todas las actualizaciones de precio desde servicios externos
              </p>
            </b-list-group-item>
          </b-list-group>                    

          <b-list-group class="mb-1" v-if="configSubView.elements.configuration">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openConfiguration()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Configuración</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Configuración del módulo de costos
              </p>
            </b-list-group-item>
          </b-list-group>

          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>          
        </b-col>        
      </b-row>
    </b-col>
  </b-row>

</template>
<script>
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import WidgetVisibilityConfig from '@/components/inc/widget/WidgetVisibilityConfig'
  import ChangelogWidget from '@/components/inc/changelog/ChangelogWidget'
  import ServicesPHP from '@/components/modules/users/php/staff/services'
  import WidgetMasonry from '@/components/inc/widget/WidgetMasonry'
  import DashboardWidgetsHelper from '@/components/inc/widget/DashboardWidgetsHelper'

  export default {
    mixins: [DashboardWidgetsHelper],
    components: {
      Widget,
      WidgetVisibilityConfig,
      WidgetMasonry,
      ChangelogWidget,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.COSTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.COSTOS,
          profile_id: Profiles.PERSONAL,
          elements: {}
        },
        configSubView: {
          module_id: Modules.COSTOS,
          profile_id: Profiles.PERSONAL,
          elements: {
            configuration: true,
            products: true,
            import: true,
            external: true,
            product_suppliers_by_barcode: true,
            php_custom: true,
          }
        },          
        primaryColor: '',
        arr: {
          PHPCustom: []
        }
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      this.initDashboardWidgets()

      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.configuration = Helper.showAccessView(this.configSubView, 'configuration')
      this.configSubView.elements.products = Helper.showAccessView(this.configSubView, 'crudPriceListSuppliers')
      this.configSubView.elements.import = Helper.showAccessView(this.configSubView, 'crudImportLog')
      this.configSubView.elements.external = Helper.showAccessView(this.configSubView, 'crudUpdateExternal')
      this.configSubView.elements.product_suppliers_by_barcode = Helper.showAccessView(this.configSubView, 'crudProductSuppliersByBarcode')
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */                       
    },
    mounted() {
      this.setup()
      this.getPHPCustom()
    }, 
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      },
      openConfiguration() {
        this.$router.push({ name: 'CostsStaffConfiguration' })
      },
      openSuppliersProducts() {
        this.$router.push({ name: 'CostsStaffPriceListSuppliers' })
      },
      openImportLog() {
        this.$router.push({ name: 'CostsStaffPriceListSuppliersImportLog' })
      },
      openUpdateExternal() {
        this.$router.push({ name: 'CostsStaffPriceListSuppliersUpdateExternal' })
      },
      openProductSuppliersByBarcode() {
        this.$router.push({ name: 'CostsStaffProductSuppliersByBarcode' })
      },


      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.COSTOS)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }      
    }
  }
</script>

<style>

</style>
